import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
import { useState } from "react";
import { FormCreateFinanceAccount } from "./form-create-finance-account";
import { FormEditFinanceAccount } from "./form-edit-finance-account";

type FormFinanceAccountProps = {
  children: React.ReactNode;
  id?: string;
  isEdit?: boolean;
};

export function FormFinanceAccount({
  children,
  id,
  isEdit = false,
}: FormFinanceAccountProps) {
  const [open, setOpen] = useState(isEdit);
  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>{children}</DrawerTrigger>
      <DrawerContent className="h-[94vh]">
        {id ? (
          <FormEditFinanceAccount id={id} handleClose={() => setOpen(false)} />
        ) : (
          <FormCreateFinanceAccount handleClose={() => setOpen(false)} />
        )}
      </DrawerContent>
    </Drawer>
  );
}
